import React, { useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { login } from "../redux/actions/login";
import { connect } from "react-redux";
import { useSelector } from "react-redux";
import { Button, Input } from "../components";
import HelpButton from "../components/button/helpButton";
import {
  FaFacebookF,
  FaYoutube,
  FaTwitter,
  FaLinkedinIn,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import ROUTES from "../free/constants/routes";

// get user data from state
const authData = (state) => state.auth;

function Login(props) {
  const data = useSelector(authData);
  let navigate = useNavigate();
  const LoginSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email")
      .required("Please enter the correct email."),
    password: Yup.string()
      .required("Please enter the correct password.")
      .min(5, "Password should be 5 characters minimum."),
  });

  const formik = useFormik({
    initialValues: { email: "", password: "" },
    validationSchema: LoginSchema,
    onSubmit: (values) => {
      props.login({ email: values.email, password: values.password });
    },
  });

  useEffect(() => {
    let clientCampaigns = data && data.client && data.client.campaigns;
    if (clientCampaigns < 1) {
      navigate(`${ROUTES.FREEPLAN}`, { replace: true });
    } else if (clientCampaigns > 0) {
      navigate(`${ROUTES.FREEPLAN}`, { replace: true });
    } else {
      navigate(`${ROUTES.LOGIN}`, { replace: true });
    }
  }, [data, navigate]);

  const token = sessionStorage.getItem('token')


  return (
    <div className="flex justify-center items-center">
      {/* <HelpButton screen="login" /> */}
      <form
        className="w-full z-10 my-10 bg-white drop-shadow-md rounded-lg  py-10  2xl:px-14 xl:px-14 lg:px-10 md:px-8 px-6"
        onSubmit={formik.handleSubmit}
        noValidate
      >
        {/* begin::Heading */}
        <div className="text-center mb-6">
          <h1 className="text-[#292929] 2xl:text-4xl xl:text-4xl lg:text-4xl md:text-4xl font-medium text-2xl">
            Welcome to our
          </h1>
          <h1 className="text-[#292929] 2xl:text-4xl xl:text-4xl lg:text-4xl md:text-3xl font-bold text-3xl">
            Game Creation Platform
          </h1>
        </div>
        {/* begin::Heading */}

        <Input
          {...formik.getFieldProps("email")}
          label="Email"
          placeholder="Write Your Email Here"
          type="email"
          name="email"
          autoComplete="off"
          isError={formik.errors.email}
        />
        {formik.touched.email && formik.errors.email && (
          <div>
            <span className="text-red-600 text-base font-semibold">
              {formik.errors.email}
            </span>
          </div>
        )}

        <div className="mt-4">
          <Input
            {...formik.getFieldProps("password")}
            label="Password"
            type="password"
            name="password"
            isError={formik.errors.password}
            placeholder="*******"
            autoComplete="off"
          />
          {formik.touched.password && formik.errors.password && (
            <div>
              <span className="text-red-600 text-base font-semibold">
                {formik.errors.password}
              </span>
            </div>
          )}
        </div>

        <div className="my-3">
          {/* {data.loggingIn === false ? <ErrorMessage text={data.message} /> : null} */}
          {data.loggingIn === false ? (
            <div>
              <span className="text-red-600 text-base font-semibold">
                {data.message}
              </span>
            </div>
          ) : null}
        </div>

        {/* begin::Action */}
        <div className="mt-6">
          {/* formik.errors.password */}
          {data.loading ? (
            <Button
              customStyle="w-full  text-[1rem]"
              name="Please Wait"
              type="button"
            />
          ) :  (
            <Button
              customStyle={` w-full text-[1rem] ${data.loggingIn === false ?  'bg-[#6D7172] hover:bg-[#6D7172]' : 'bg-[#007E8B]'}`}
              name="Login"
              type="submit"
            />
          )  
        
        }
        </div>

        {
          !token ?
            <div className="mt-6">
              {/* formik.errors.password */}
              <a className="hover:no-underline" onClick={() => navigate('signup')} rel="noreferrer" target='_blank'>
                <button type="button" className=" px-6 py-3 bg-[#FBD10B] w-full rounded leading-normal text-center" style={{ display: 'block' }}>
                  <span className="w-100 no-underline	 d-block text-white font-bold text-lg capitalize ">Sign Up</span>
                </button>
              </a>
            </div> 
            : 
            null
        }




        {/* end::Action */}

        <div className="mt-6">
          <p className="text-[#4F4F4F] font-medium text-lg text-center">
            Connect With Us
          </p>

          <div className="flex flex-row items-center mt-4 justify-center ">
            <a target="_blank" href="https://www.facebook.com/games.talent/">
              <div className="mx-1 cursor-pointer hover:bg-yellow-500 w-8 h-8 flex items-center justify-center rounded-full bg-[#FFD700] p-2">
                <FaFacebookF className="text-white" />
              </div>
            </a>
            <a
              target="_blank"
              href="https://www.youtube.com/channel/UCTjzlMHDYCqi2XubmFvb0Jw"
            >
              <div className="mx-1 cursor-pointer hover:bg-yellow-500 w-8 h-8 flex items-center justify-center rounded-full bg-[#FFD700] p-2">
                <FaYoutube className="text-white" />
              </div>
            </a>
            <a target="_blank" href="https://twitter.com/GamesTalent">
              <div className="mx-1 cursor-pointer hover:bg-yellow-500 w-8 h-8 flex items-center justify-center rounded-full bg-[#FFD700] p-2">
                <FaTwitter className="text-white" />
              </div>
            </a>

            <a
              target="_blank"
              href="https://linkedin.com/company/thetalentgames"
            >
              <div className="mx-1 cursor-pointer hover:bg-yellow-500 w-8 h-8 flex items-center justify-center rounded-full bg-[#FFD700] p-2">
                <FaLinkedinIn className="text-white" />
              </div>
            </a>
          </div>
        </div>
      </form>
    </div>
  );
}

const mapStateToProps = ({ state }) => ({
  state,
});

export default connect(mapStateToProps, { login })(Login);
